var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1875 27.9978C3.1875 31.3219 3.84223 34.6134 5.1143 37.6845C6.38637 40.7555 8.25088 43.546 10.6014 45.8964C12.9518 48.2469 15.7423 50.1114 18.8133 51.3835C21.8844 52.6556 25.1759 53.3103 28.5 53.3103C31.8241 53.3103 35.1156 52.6556 38.1867 51.3835C41.2577 50.1114 44.0482 48.2469 46.3986 45.8964C48.7491 43.546 50.6136 40.7555 51.8857 37.6845C53.1578 34.6134 53.8125 31.3219 53.8125 27.9978C53.8125 24.6737 53.1578 21.3822 51.8857 18.3111C50.6136 15.2401 48.7491 12.4496 46.3986 10.0992C44.0482 7.74868 41.2577 5.88417 38.1867 4.6121C35.1156 3.34003 31.8241 2.6853 28.5 2.6853C25.1759 2.6853 21.8844 3.34003 18.8133 4.6121C15.7423 5.88417 12.9518 7.74868 10.6014 10.0992C8.25088 12.4496 6.38637 15.2401 5.1143 18.3111C3.84223 21.3822 3.1875 24.6737 3.1875 27.9978Z",
    stroke: "#13D16A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 38.1228L38.625 17.8728",
    stroke: "#13D16A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.625 38.1228L18.375 17.8728",
    stroke: "#13D16A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircle);
export default __webpack_public_path__ + "static/media/cross-circle.3a155f24a3e00761b4eed4878a166dd3.svg";
export { ForwardRef as ReactComponent };